import React from "react";

// Material
import { CircularProgress, Box, makeStyles } from "@material-ui/core";

// Styles
const useStyles = makeStyles((theme) => ({
	loader: {
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		color: theme.palette.primary.main,
		backgroundColor: theme.palette.background.white,
		width: "100%",
	},
}));

export default function Loader() {
	const classes = useStyles();
	return (
		<Box className={classes.loader}>
			<CircularProgress color="primary" />
		</Box>
	);
}
